import { FaUser } from "react-icons/fa";
import ChevronDoubleUpDown from '@/assets/chevron-double-up-down.svg';
import ClientSwitcherDrawer from '../ClientSwitcherDrawer';
import type { DashboardClient } from '../../utils/client.utils';

type MatchmakingHeaderProps = {
  clients: Array<{ id: string; name: string; avatar: string }>;
  selectedClientId: string | null;
  onSelectClient: (clientId: string) => void;
  isDrawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  selectedClient: DashboardClient | null;
  clientsLoading: boolean;
  hasClients: boolean;
};

export const MatchmakingHeader = ({
  clients,
  selectedClientId,
  onSelectClient,
  isDrawerOpen,
  setDrawerOpen,
  selectedClient,
  clientsLoading,
  hasClients,
}: MatchmakingHeaderProps) => {
  const selectedClientName = selectedClient?.profile.name ?? 'your client';
  const clientAvatar = selectedClient?.avatar ?? '';
  const clientButtonLabel = clientsLoading
    ? 'Loading clients...'
    : hasClients
      ? selectedClientName
      : 'Select Client';

  return (
    <div className="flex flex-wrap items-center gap-4">
      <h1 className="font-recoleta text-3xl text-[#111827]">
        bQuest Navigator
      </h1>
      <div className="ml-auto flex items-center">
        <div className="relative">
          <button
            type="button"
            onClick={() => setDrawerOpen(!isDrawerOpen)}
            className="flex items-center gap-3 rounded-md border border-[#026857] bg-[#026857]/10 px-4 py-1 text-[#026857] hover:bg-[#026857]/20 transition-colors"
          >
            <span className="flex items-center gap-3 py-2 font-medium text-base">
              <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-[#026857] bg-[#026857]/10">
                {clientsLoading ? (
                  <FaUser className="h-5 w-5 text-[#026857]" />
                ) : clientAvatar ? (
                  <img
                    src={clientAvatar}
                    alt={clientButtonLabel}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <FaUser className="h-5 w-5 text-[#026857]" />
                )}
              </span>
              <span className="text-[#026857] text-xl">
                {clientButtonLabel}
              </span>
            </span>
            <img
              src={ChevronDoubleUpDown}
              alt="Expand"
              className="w-6 h-6"
            />
          </button>
          <ClientSwitcherDrawer
            isOpen={isDrawerOpen}
            clients={clients}
            selectedClientId={selectedClientId ?? ''}
            onSelectClient={onSelectClient}
            onClose={() => setDrawerOpen(false)}
          />
        </div>
      </div>
    </div>
  );
};

